<div class="custom-header" (dblclick)="toggleGroup()">
    <!-- a11y (WCAG 2.1.1 Keyboard / 2.4.3 Focus Order / 4.1.2 Name, Role, Value):
         this row is AG Grid's full-width renderer for a learning-curve group,
         which is NOT governed by defaultColDef.suppressKeyboardEvent — AG Grid
         focuses the row container itself and never routes Tab/Arrow keys
         through the column-level suppressors used by the rest of the grid.
         Each of these three controls is a real native Tab stop
         (tabindex="0", matched by the shared "group-row-control" class) so
         Tab reaches them directly (ESP-18550: "Week controls" / "Add Class"
         must receive keyboard focus via Tab); `enableGridInteractiveControlTabOrder`
         (wired in NewHireComponent#onGridReady) manually walks Tab between
         them and the rest of the grid because AG Grid's row-level Tab handler
         never descends into a full-width row's own nested buttons.
         `enableFullWidthRowKeyboardNav` additionally lets Left/Right Arrow
         rove across them and reroutes Up/Down Arrow to the adjacent row. -->
    <button type="button"
            tabindex="0"
            class="ag-group-toggle group-row-control"
            [class.visible]="hasChildren"
            [class.invisible]="!hasChildren"
            [class.ag-group-contracted]="isGroupCollapsed"
            [class.ag-group-expanded]="!isGroupCollapsed"
            [disabled]="!hasChildren"
            [attr.aria-hidden]="!hasChildren"
            [attr.aria-expanded]="!isGroupCollapsed"
            [attr.aria-label]="(isGroupCollapsed ? 'multi.mu.group.expand.aria' : 'multi.mu.group.collapse.aria') | translate:{ '0': displayValue }"
            (click)="toggleGroup()">
      <span class="ag-icon" [ngClass]="isGroupCollapsed ? 'ag-icon-tree-closed' : 'ag-icon-tree-open'" aria-hidden="true">
      </span>
    </button>
    <button type="button"
            tabindex="0"
            class="group-name group-row-control"
            title="{{ displayValue }}"
            (click)="onGroupNameClick($event)">{{ displayValue }} ({{params.data.trainingWeeks}} {{'plan.settings.weeks' | translate}})</button>
    <div class="action-buttons-container">
    <span class="action-buttons">
        <!-- <i class="icon icon-add" (click)="onAdd()" pTooltip="Add Class" tooltipPosition="left"></i> -->
        <button id="add-class"
        tabindex="0"
        class="btn btn-secondary btn-small no-right-margin group-row-control" (click)="onAdd($event)">{{'learning.curve.group.add.class.btn' | translate}}</button>
    </span>
    </div>
  </div>
